// Hell/Dunkel: System als Vorgabe, die Wahl in localStorage. `theme.js` im
// <head> setzt sie vor dem ersten Zeichnen; hier wird nur umgeschaltet.

import { useState } from "react";

export type Theme = "system" | "light" | "dark";
export const THEME_KEY = "sc-platform-theme";

export function readTheme(): Theme {
  try {
    const t = localStorage.getItem(THEME_KEY);
    return t === "light" || t === "dark" ? t : "system";
  } catch { return "system"; }
}

export function applyTheme(value: Theme): void {
  try {
    if (value === "system") localStorage.removeItem(THEME_KEY); else localStorage.setItem(THEME_KEY, value);
  } catch { /* privates Fenster */ }
  if (value === "system") delete document.documentElement.dataset.theme; else document.documentElement.dataset.theme = value;
}

const CHOICES: ReadonlyArray<readonly [Theme, string]> = [["system", "System"], ["light", "Hell"], ["dark", "Dunkel"]];

export function ThemeSwitch() {
  const [theme, setTheme] = useState<Theme>(readTheme);
  return (
    <div className="pf-theme" role="group" aria-label="Darstellung">
      {CHOICES.map(([v, label]) => (
        <button key={v} type="button" aria-pressed={theme === v} onClick={() => { applyTheme(v); setTheme(v); }}>{label}</button>
      ))}
    </div>
  );
}
